import { Navigate } from "react-router-dom";
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import Logoicon from '../Logo/LogoIcon';
import config from "../../../config.js";

import {
  AppBar,
  Badge,
  Box,
  IconButton,
  Toolbar,
  Menu,
  MenuItem,
  Button,
  Avatar,
  Divider,
  ListItemIcon,
  Typography,
  Tooltip
} from "@mui/material";



import React, { useState, useEffect } from "react";



const Header = (props) => {
  const designation=localStorage.getItem('designation');
  const userId=localStorage.getItem('userId');
  const dept = localStorage.getItem('department');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [loggedout,Setloggedout] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const[changePassword,setchangePassword]=useState(false);
  const fetchnotification = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/show-notification/${userId}`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      setNotifications(jsonData);
    }
    catch(err){
      console.error(err.message);
    }
  }

  const handleDeleteNotification = async (notificationId) => {
    try {
        await fetch(`${config.BASE_URL_IP}/wob/delete-notification/${notificationId}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        });

        // Remove the notification from the state
        const updatedNotifications = notifications.filter(notification => notification.notification_id !== notificationId);
        setNotifications(updatedNotifications);

        // Update local storage to remove the notification
        localStorage.setItem("notifications", JSON.stringify(updatedNotifications));
    } catch (error) {
        console.error("Error deleting notification:", error);
    }
};

  
  useEffect(() => {
    // // Fetch notifications from local storage when the component mounts
    // const storedNotifications = JSON.parse(localStorage.getItem("notifications")) || [];
    // // Filter notifications based on the logged-in user's ID
    // const userNotifications = storedNotifications.filter(notification => notification.userId === userId);
    // setNotifications(userNotifications);
    fetchnotification();
}, [userId]);

  const handleNotificationClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = async (index) => {
    console.log(index);
    // Remove the notification at the specified index from the state
    const updatedNotifications = [...notifications];
    const deletedNotification = updatedNotifications.splice(index, 1)[0];
    if (!deletedNotification) {
      console.error("Deleted notification is undefined.");
      setAnchorEl(null);
      return; // Exit the function if deletedNotification is undefined
  }
    // setNotifications(updatedNotifications);
    const notificationId = deletedNotification.notification_id;
    console.log(notificationId);
    // Update local storage to remove the notification
    localStorage.setItem("notifications", JSON.stringify(updatedNotifications));

    setAnchorEl(null);
  };
  // 4


  const [anchorEl4, setAnchorEl4] = React.useState(null);

  const handleClick4 = (event) => {
    setAnchorEl4(event.currentTarget);
  };

  const handleClose4 = () => {
    setAnchorEl4(null);
  };

  const handleClose5 = () => {
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('designation');
    localStorage.removeItem('department');
    localStorage.removeItem('department_id');
    localStorage.removeItem('email');
    localStorage.removeItem('userID');
    Setloggedout(true);
  };

  const handleClose6 =() =>{
    console.log("hi")
    setchangePassword(true);
  }

  if(loggedout)
  {
    return(
      <>
      <Navigate to={"/workorder/wof/login"}/>
      </>
    )
  }

  if(changePassword){
    return(
      <Navigate to={"/workorder/wof/login/reset-password"}/>
    )
  }

  return (
    <AppBar sx={props.sx}  className={props.customClass} style={{width:"99%",borderRadius:"30px",margin:"10px 10px 10px -10px"}}>
      <Toolbar>
        <Logoicon style={{}}></Logoicon>
        <Box flexGrow={1} />

        {(designation!='Director') && (<IconButton
          aria-label="menu"
          color="inherit"
          aria-controls="notification-menu"
          aria-haspopup="true"
          onClick={handleNotificationClick}
        >
          <Badge badgeContent={notifications.length} color="error">
            <NotificationsNoneOutlinedIcon />
          </Badge>
        </IconButton>)}
        <Menu
          id="notification-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => handleClose(-1)}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          sx={{
            "& .MuiMenu-paper": {
              height:"200px",
              width: "400px",
              right: 0,
              top: "70px !important",
            },
            "& .notification-message": {
              flexGrow: 1,
              whiteSpace: "normal", 
            },
          }}
        >
            {notifications.map((notification, index) => (
            <MenuItem key={index} sx={{ display: 'flex', alignItems: 'center', backgroundColor: index % 2 === 0 ? "#f0f0f0" : "transparent" }}>
            <ListItemIcon>
            </ListItemIcon>
            <Typography variant="body1" className="notification-message">
                {notification.notification_msg} 
            </Typography>
            <Button onClick={() => handleDeleteNotification(notification.notification_id)}>OK</Button>
            </MenuItem>        
          ))}
        </Menu> 
        
        <Box
          sx={{
            width: "1px",
            backgroundColor: "rgba(0,0,0,0.1)",
            height: "25px",
            ml: 1,
          }}
        ></Box>
        <Button
          aria-label="menu"
          color="inherit"
          aria-controls="profile-menu"
          aria-haspopup="true"
          onClick={handleClick4}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Avatar
              sx={{
                width: "30px",
                height: "30px",
              }}
            />
          </Box>
        </Button>
        <Menu
          id="profile-menu"
          anchorEl={anchorEl4}
          keepMounted
          open={Boolean(anchorEl4)}
          onClose={handleClose4}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          sx={{
            "& .MuiMenu-paper": {
              width: "250px",
              right: 0,
              top: "70px !important",
            },
          }}
        >
          <MenuItem onClick={handleClose4}>
            <Avatar
              sx={{
                width: "35px",
                height: "35px",
              }}
            />
             <Tooltip title={dept} arrow>
            <Box
              sx={{
                ml: 2,
              }}
            >
             {dept}
            </Box>
            </Tooltip>
          </MenuItem>
          <Divider />
          <MenuItem onClick={()=>{handleClose6()}}>
            <ListItemIcon>
              <SettingsOutlinedIcon fontSize="small" />
            </ListItemIcon>
            Change Password
          </MenuItem>
          <MenuItem onClick={handleClose5}>
            <ListItemIcon>
              <LogoutOutlinedIcon fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
